import { render, staticRenderFns } from "./re-login.vue?vue&type=template&id=86d2bdfa&%3Akey=componentKey&"
import script from "./re-login.vue?vue&type=script&lang=js&"
export * from "./re-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports